
export class SuspectMap {
    customersNearPlantData: Array<any>;
    apPlantsData: Array<any>;
    competitorPlantsData: Array<any>;
    competitorAPPlantsData: Array<any>;
    proposedPlantsData: Array<any>;
    bullsEyeData: Array<any>;
    globalIndSegments: Array<any>;
    heatMap1Data: Array<any>;
    heatMap2Data: Array<any>;

    constructor(){
        this.customersNearPlantData = [];
        this.apPlantsData = [];
        this.competitorPlantsData = [];
        this.competitorAPPlantsData = [];
        this.proposedPlantsData = [];
        this.bullsEyeData = [];
        this.globalIndSegments = [];
        this.heatMap1Data = [];
        this.heatMap2Data = [];
    }
}